import _ from 'lodash'

export const getLanguages = (state) => {
    return _.values(state.languages)
}

export const getUsers = (state) => {
    return _.values(state.users)
}

export const getProjects = (state) => {
    return _.values(state.projects)
}

export const getCurrentProject = (state) => {
    const project = { ...state.currentProject }
    Object.keys(project).forEach((key) => {
        if(project[key] === null) {
            project[key] = '';
        }
    })
    return { ...project, projectLanguage: _.has(project,'projectLanguageId') ? state.languages[project.projectLanguageId] : {} }
}

export const getCurrentProjectSuppliers = (state) => {
    return state.currentProjectSuppliers
}

export const getSearchTerm = (state) => {
    return state.searchTerm
}

export const getCurrentUser = (state) => {
    return state.user
}

export const getToken = (state) => {
    return state.token
}

export const getIsLoggedIn = (state) => {
    return !!state.user
}



// WEBPACK FOOTER //
// ./src/store/selectors.js